import { ServiceBase } from '../../../../../../core/services/ServiceBase'
import InternationalSearchProxy from '../proxies/InternationalSearchProxy'

class InternationalSearchService extends ServiceBase {
  getCompany(params) {
    return this.getData(() => InternationalSearchProxy.getCompany(params))
  }
}

export default new InternationalSearchService()
